import { useEffect, useState } from 'react'

export const useCopied = (): [boolean, (copied: boolean) => void] => {
  const [isCopied, setIsCopied] = useState<boolean>(false)

  /**
   * This useEffect will restart the isCopied value to false after 2 seconds, when the user gets notified that the text was copied
   */
  useEffect(() => {
    let id: NodeJS.Timeout

    if (isCopied) {
      id = setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    }

    return () => clearTimeout(id)
  }, [isCopied, setIsCopied])

  return [isCopied, setIsCopied]
}
